module.exports = __webpack_public_path__ + "static/media/dashboard.6eb7eabc.webp";